<template>
  <div class="yunxiao class-paike-add paike-date">
    <van-form class="date-plan" v-for="(item, idx) of value" :key="idx" input-align="right">
      <div class="date-plan-main">
        <div class="subtil van-hairline--bottom">
          <div class="txt">上课日期</div>
          <van-icon
            class="delbtn"
            name="delete-o"
            size="24"
            v-if="value.length > 1"
            @click="deleteTimeArrange(idx)"
          />
        </div>

        <van-cell title="日期" is-link @click="toChooseDates(item)">
          <template>
            <div v-if="item.courseDateList.length > 0" style="color: var(--g8)">
              <div class="van-ellipsis" style="color: var(--g8)">
                <span v-if="item.courseDateList.length > 1">
                  已选{{ item.courseDateList.length }}天
                </span>
                <span v-else>
                  {{ item.courseDateList[0] | formatDatetime('yyyy-MM-dd') }}
                </span>
              </div>
              <span
                v-if="item.courseDateList.length > 1"
                @click.stop="showChoosedDatesPopup(item)"
                style="color: var(--tlc); font-size: var(--fs-md)"
              >
                查看已选日期
              </span>
            </div>
            <div v-else style="color: var(--g5)">请选择(可多选)</div>
          </template>
        </van-cell>

        <van-cell v-for="(time, tIdx) of item.courseTimeRangeList" :key="tIdx">
          <template #title>
            <div class="time-arrage-title">
              <van-icon
                v-if="item.courseTimeRangeList.length > 1"
                class="delete-icon"
                class-prefix="vxs-icon"
                name="system_del"
                color="var(--c3)"
                @click="deleteTimes(item, tIdx)"
              />时段
            </div>
          </template>
          <template>
            <div class="time-arrage-value" @click="updateCusTime(time)">
              <div
                v-if="time.startTime && time.endTime"
                class="van-ellipsis"
                style="color: var(--g8)"
              >
                <span>{{ time.startTime }}～{{ time.endTime }}</span>
                <span class="time-arrage-minutes">{{
                  app.tool.date.getDiffTimeDesc(time.startTime, time.endTime)
                }}</span>
              </div>
              <div v-else>请选择</div>
              <div class="always-tag" v-if="isQuick" @click.stop="updateTime(time)">常用时段</div>
            </div>
          </template>
        </van-cell>

        <div class="addbtns" v-if="!isQuick">
          <div class="btn" @click="addTimes(item)">
            <div>添加常用时段</div>
          </div>
          <div class="midline van-hairline--left"></div>
          <div class="btn" @click="addCusTimes(item)">
            <div>添加自定义时段</div>
          </div>
        </div>

        <!-- <van-cell class="add-time-arrage-cell" v-if="!isQuick">
          <template #title>
            <div class="add-time-arrage" @click="addMoreTimes(item)">
              <div><i class="vxs-icon vxs-icon-system_add"></i>添加时段</div>
            </div>
          </template>
        </van-cell> -->
      </div>
    </van-form>
    <div class="add-btn more" @click="addMore" v-if="!isQuick">
      <van-icon name="plus" />&nbsp;
      <div>新增上课日期</div>
    </div>
    <van-calendar
      get-container="body"
      type="multiple"
      color="var(--c1)"
      :min-date="minStartDate"
      :max-date="new Date(2030, 11, 31)"
      :default-date="multiDefaultDate"
      v-model="showMultiDatePicker"
      @confirm="multiPickerConfirm"
    />
    <van-popup
      class="paike-date-show-dates-popup"
      v-model="showPopup"
      :safe-area-inset-bottom="true"
      position="bottom"
      closeable
      getContainer="body"
      :style="{ height: '372px' }"
    >
      <div class="title">已选日期({{ showPopupDates.length }})</div>
      <div class="body">
        <div v-for="date of showPopupDates" :key="date.getTime()">
          {{ date | formatDatetime('yyyy-MM-dd') }}
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
/**
 * 将排课日期时间相关的操作，单独使用一个组件处理
 */
function timeGetTime(str) {
  return Number(str.substr(0, 2) + str.substr(3, 2));
}

export default {
  name: 'paikeDate',
  props: {
    value: Array,
    isQuick: {
      type: Boolean,
      default: false,
    },
    minStartDate: {
      type: Date,
      default: () => new Date('2020/01/01'),
    },
  },
  data() {
    return {
      showMultiDatePicker: false,
      showPopup: false,
      showPopupDates: [],
      multiDefaultDate: [],
    };
  },
  methods: {
    addMore() {
      this.value.push({
        courseDateList: [],
        courseTimeRangeList: [],
      });
    },
    deleteTimeArrange(idx) {
      this.value.splice(idx, 1);
    },
    toChooseDates(item) {
      this.multiDefaultDate.splice(0);
      let datesArr =
        item.courseDateList && item.courseDateList.length ? item.courseDateList : [new Date()];
      this.multiDefaultDate.push(...datesArr);
      this.multiDefaultDateItem = item;
      this.showMultiDatePicker = true;
    },
    showChoosedDatesPopup(item) {
      this.showPopup = true;
      this.showPopupDates = item.courseDateList;
    },
    multiPickerConfirm(dates) {
      this.multiDefaultDateItem.courseDateList = dates;
      this.showMultiDatePicker = false;
    },
    async addCusTimes(item) {
      let res = await app.x3.picker.timeInterval();
      item.courseTimeRangeList.push({
        startTime: res.value1,
        endTime: res.value2,
      });
    },
    async updateCusTime(time) {
      let res = await app.x3.picker.timeInterval({
        value1: time.startTime,
        value2: time.endTime,
      });
      time.startTime = res.value1;
      time.endTime = res.value2;
    },
    // 常用时段
    async addTimes(item) {
      const res = await app.x3.side.xsTimePeriods({
        config: {},
      });
      item.courseTimeRangeList.push(...res);
    },
    async updateTime(time) {
      const res = await app.x3.side.xsTimePeriods({
        config: {
          radio: true,
        },
      });
      Object.assign(time, res);
    },
    // addMoreTimes(item) {
    //   let lastTime = item.courseTimeRangeList.slice(-1)[0];

    //   // 如果上一行有填写时间
    //   // 添加新等时，新行自动填写时间
    //   // 时间以上一行有填写时间的结束时间为开始时间
    //   // 结束时间以上一行结束时间，加上上一行的时间差值
    //   if (lastTime.startTime && lastTime.endTime) {
    //     let endHour = Number(lastTime.endTime.substr(0, 2));
    //     if (endHour < 24) {
    //       let startTime = new Date('2010/01/01 ' + lastTime.startTime + ':00');
    //       let endTime = new Date('2010/01/01 ' + lastTime.endTime + ':00');
    //       let dateDiffSeconds = Math.floor((endTime - startTime) / 1000);
    //       startTime = new Date(startTime.setSeconds(startTime.getSeconds() + dateDiffSeconds));
    //       endTime = new Date(endTime.setSeconds(endTime.getSeconds() + dateDiffSeconds));

    //       if (endTime.getHours() < startTime.getHours()) {
    //         // 说明超过24小时，到第二天了，直接返回个空
    //         return item.courseTimeRangeList.push({ startTime: '', endTime: '' });
    //       }

    //       return item.courseTimeRangeList.push({
    //         startTime: app.tool.date.formatDatetime(startTime, 'hh:mm'),
    //         endTime: app.tool.date.formatDatetime(endTime, 'hh:mm'),
    //       });
    //     }
    //   }
    //   return item.courseTimeRangeList.push({ startTime: '', endTime: '' });
    // },
    deleteTimes(item, idx) {
      item.courseTimeRangeList.splice(idx, 1);
    },
    verify(str = '排课') {
      // 单独检查每个排课设置是否有冲突或输入合法
      for (let item of this.value) {
        if (!item.courseDateList.length) {
          vant.Toast(`请选择${str}日期`);
          return false;
        }

        // 校验上课时段是否有空值
        const timeValidateArr = item.courseTimeRangeList.filter(item => {
          return item.startTime && item.endTime;
        });
        if (timeValidateArr.length !== item.courseTimeRangeList.length) {
          vant.Toast('上课时段不能为空');
          return false;
        }
        if (this.hasCrossTime(item.courseTimeRangeList)) {
          vant.Toast('上课时段有冲突');
          return false;
        }
      }

      // 检查多个排课的时段选择是否有冲突
      let dateObj = {};
      // 先将多个排课的时段以同一个日期为发展收集起来
      let hasCurrentDate = false;
      for (let item of this.value) {
        item.courseDateList.forEach(date => {
          let prop = app.tool.date.formatDatetime(date, 'yyyy-MM-dd');
          if (!hasCurrentDate && prop === app.tool.date.formatDatetime(new Date(), 'yyyy-MM-dd')) {
            hasCurrentDate = true;
          }
          if (!dateObj[prop]) {
            dateObj[prop] = [];
          }
          dateObj[prop].push(...item.courseTimeRangeList);
        });
      }
      // 检查同一个日期的时段是否冲突
      for (const prop in dateObj) {
        if (Object.hasOwnProperty.call(dateObj, prop)) {
          let hasCrossTime = this.hasCrossTime(dateObj[prop], hasCurrentDate && str === '约课');
          if (hasCrossTime) {
            vant.Toast(hasCrossTime.msg || '上课时段有冲突');
            return false;
          }
        }
      }

      return true;
    },
    // 检测是否有交叉时间
    hasCrossTime(times, verifyBeforeDate) {
      for (let i = 0; i < times.length; i++) {
        let currenHour = app.tool.date.formatDatetime(new Date(), 'hh:mm');
        if (verifyBeforeDate && timeGetTime(times[i].startTime) < timeGetTime(currenHour)) {
          return { msg: '发布约课的时段不可早于当前时间' };
        }
        for (let j = i + 1; j < times.length; j++) {
          if (timeGetTime(times[i].startTime) < timeGetTime(times[j].startTime)) {
            if (timeGetTime(times[i].endTime) > timeGetTime(times[j].startTime)) {
              return true;
            }
          } else {
            if (timeGetTime(times[i].startTime) < timeGetTime(times[j].endTime)) {
              return true;
            }
          }
        }
      }
    },
  },
  created() {
    if (this.isQuick) {
      this.multiDefaultDate = [new Date()];
    }
  },
};
</script>

<style lang="scss" scoped>
.yunxiao.class-paike-add.paike-date {
  margin: calc(var(--gap) * 16) calc(var(--gap) * 12);
  > div,
  .date-plan {
    background-color: var(--white);
  }
  .date-plan {
    margin-bottom: calc(var(--gap) * 12);
    border-radius: var(--radius-sm);
    .date-plan-main {
      padding: 0 calc(var(--gap) * 16);

      .subtil {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: calc(var(--gap) * 10) 0;
        .txt {
          font-size:var(--fs-md);
          line-height:var(--lh-md);
        }
        .delbtn {
          color: var(--g6);
        }
      }
      .addbtns {
        display: flex;
        align-items: center;
        color: var(--c1);
        font-size: var(--fs-md);
        line-height: var(--lh-md);
        .btn {
          flex: 1;
          padding: calc(var(--gap) * 12);
          text-align: center;
        }
      }
      .midline {
        width: 2px;
        height: var(--lh-md);
      }
    }
    .time-arrage-title {
      i {
        margin-right: calc(var(--w) * 8);
      }
    }
    .time-arrage-value {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      color: var(--g5);
      .time-arrage-minutes {
        font-size: var(--fs-sm);
        margin-left: calc(var(--gap) * 12);
      }
      i {
        margin-left: 8px;
      }
    }
    .add-time-arrage {
      color: var(--tlc);
      display: flex;
      justify-content: space-between;
      align-items: center;
      i {
        margin-right: calc(var(--gap) * 4);
      }
    }
  }
  .always-tag {
    color: var(--c1);
    margin-left: calc(var(--gap) * 8);
  }
  .add-btn {
    display: flex;
    font-size: var(--fs-md);
    line-height: var(--lh-md);
    padding: calc(var(--gap) * 12);
    align-items: center;
    justify-content: center;
    border-radius: var(--radius-sm);
    border: none;
    .vxs-icon {
      font-size: var(--fs-lg);
    }
  }
}
</style>
<style lang="scss">
.yunxiao.class-paike-add.paike-date {
  .date-plan {
    .van-cell,
    .van-field {
      padding: calc(var(--gap) * 15) 0;
      &::after {
        right: 0;
        left: 0;
      }
    }
    .van-cell__title {
      width: 68px;
      flex: unset;
    }
    .add-time-arrage-cell .van-cell__title {
      width: 100%;
    }
    .van-cell__title,
    .van-field__label,
    .van-field__value,
    .van-cell__value {
      color: var(--g8);
    }
    .van-cell__title,
    .van-field__label {
      color: var(--g7);
    }
  }
}
.paike-date-show-dates-popup {
  display: flex;
  flex-direction: column;
  border-radius: var(--radius-lg) var(--radius-lg) 0 0;
  color: var(--g8);
  > .title {
    margin-bottom: calc(var(--gap) * 8);
    height: calc(var(--w) * 48);
    font-size: var(--fs-lg);
    line-height: calc(var(--w) * 48);
    font-weight: 500;
    text-align: center;
  }
  > .body {
    padding: 0 calc(var(--gap) * 16);
    overflow: auto;
    > div {
      display: inline-block;
      margin-bottom: calc(var(--gap) * 16);
      width: 50%;
      font-size: var(--fs-lg);
      line-height: var(--lh-lg);
    }
  }
}
</style>